<template>
  <a-drawer width="50%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">


      <a-form-model-item prop="money" >
        <span slot="label" >
          <a-tooltip>
            {{$t('提现金额')}}<template slot="title">{{$t('提现金额')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.money"  :placeholder="$t('通用.输入.请输入')+$t('提现金额')" disabled="true"/>
      </a-form-model-item>
<!--      <a-form-model-item prop="status" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('0-未审核 1-审核未通过 2-审核已通过')}}<template slot="title">{{$t('0-未审核 1-审核未通过 2-审核已通过')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item prop="accountNum" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('提现账号')}}<template slot="title">{{$t('提现账号')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-input v-model="form.accountNum" :maxLength="100" :placeholder="$t('通用.输入.请输入')+$t('提现账号')" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item prop="accountName" >
        <span slot="label" >
          <a-tooltip>
            {{$t('提现账号姓名')}}<template slot="title">{{$t('提现账号姓名')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.accountName" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('提现账号姓名')" disabled="true"/>
      </a-form-model-item>
<!--      <a-form-model-item prop="serviceChargeNum" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('提现手续费')}}<template slot="title">{{$t('提现手续费')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-input v-model="form.serviceChargeNum"  :placeholder="$t('通用.输入.请输入')+$t('提现手续费')" disabled="true"/>-->
<!--      </a-form-model-item>-->
      <a-form-model-item  prop="withdrawType" >
          <span slot="label" >
          <a-tooltip>
            {{$t('提现方式')}}<template slot="title">{{$t('提现方式')}}</template>
          </a-tooltip>
        </span>
        <a-select  v-model="form.withdrawType" disabled="true">
          <a-select-option v-for="(item, index) in withdrawTypeList" :value="item.type"
                           :key="index" >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>


      <a-form-model-item prop="alipayPaymentQrCode" v-if="form.withdrawType == 1">
         <span slot="label" >
          <a-tooltip>
            {{$t('支付宝收款二维码')}}<template slot="title">{{$t('支付宝收款二维码')}}</template>
          </a-tooltip>
        </span>
        <div>
          <img v-if="form.userAccountBindingVo.alipayPaymentQrCode" :src="form.userAccountBindingVo.alipayPaymentQrCode" style="width:120px;height:130px;"
               @click="handleRecordPreview(form.userAccountBindingVo.alipayPaymentQrCode)" alt="none"/>
        </div>
      </a-form-model-item>


      <a-form-model-item prop="weChatPaymentQrCode" v-if="form.withdrawType == 2">
         <span slot="label" >
          <a-tooltip>
            {{$t('微信收款二维码')}}<template slot="title">{{$t('微信收款二维码')}}</template>
          </a-tooltip>
        </span>
        <div>
          <img v-if="form.userAccountBindingVo.weChatPaymentQrCode" :src="form.userAccountBindingVo.weChatPaymentQrCode" style="width:120px;height:130px;"
               @click="handleRecordPreview(form.userAccountBindingVo.weChatPaymentQrCode)" alt="none"/>
        </div>
      </a-form-model-item>

      <div v-if="form.withdrawType == 3">

        <a-form-model-item prop="realName" >
          <span slot="label" >
          <a-tooltip>
            {{$t('真实姓名')}}
          </a-tooltip>
        </span>
          <h3>{{form.userAccountBindingVo.realName}}</h3>
        </a-form-model-item>
        <a-form-model-item prop="cardholderName" >
          <span slot="label" >
          <a-tooltip>
            {{$t('持卡人姓名')}}
          </a-tooltip>
        </span>
          <h3>{{form.userAccountBindingVo.cardholderName}}</h3>
        </a-form-model-item>
        <a-form-model-item prop="bankName" >
          <span slot="label" >
          <a-tooltip>
            {{$t('银行名称')}}
          </a-tooltip>
        </span>
          <h3>{{form.userAccountBindingVo.bankName}}</h3>
        </a-form-model-item>
        <a-form-model-item prop="openingBank" >
          <span slot="label" >
          <a-tooltip>
            {{$t('开户行')}}
          </a-tooltip>
        </span>
          <h3>{{form.userAccountBindingVo.openingBank}}</h3>
        </a-form-model-item>
        <a-form-model-item prop="bankNo" >
          <span slot="label" >
          <a-tooltip>
            {{$t('银行卡号')}}
          </a-tooltip>
        </span>
          <h3>{{form.userAccountBindingVo.bankNo}}</h3>
        </a-form-model-item>
      </div>


      <a-form-model-item prop="auditOpinion" >
        <span slot="label" >
          <a-tooltip>
            {{$t('审核意见')}}<template slot="title">{{$t('审核意见')}}</template>
          </a-tooltip>
        </span>
        <a-input  type="textarea" v-model="form.auditOpinion" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('审核意见')" />
      </a-form-model-item>

      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm(2)" v-if="form.status===0">
            {{$t('通过')}}
          </a-button>
          <a-button type="error" :loading="submitLoading" @click="submitForm(1)" v-if="form.status===0">
            {{$t('驳回')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getWithdraw, addWithdraw, updateWithdraw } from '@/api/user/withdraw'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      withdrawTypeList:[
        {
          name:'支付宝',
          type:'1'
        },
        {
          name:'微信',
          type:'2'
        },
        {
          name:'银行卡',
          type:'3'
        }
    ],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        shopId: null,

        money: null,

        status: 0,

        accountNum: null,

        accountName: null,

        serviceChargeNum: null,

        withdrawType: null,

        withdrawUserType: null,

        orderNo: null,

        failureReason: null,

        auditOpinion: null,

        createTime: null,

        remark: null,
        userAccountBindingVo: {
          weChatPaymentQrCode: null,
          alipayPaymentQrCode: null,
          realName: null,
          cardholderName: null,
          bankName: null,
          openingBank: null
         }

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        shopId: null,
        money: null,
        status: 0,
        accountNum: null,
        accountName: null,
        serviceChargeNum: null,
        withdrawType: null,
        withdrawUserType: null,
        orderNo: null,
        failureReason: null,
        auditOpinion: null,
        createTime: null,
        remark: null,
        userAccountBindingVo: {
          weChatPaymentQrCode: null,
          alipayPaymentQrCode: null,
          realName: null,
          cardholderName: null,
          bankName: null,
          openingBank: null
        }
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getWithdraw({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function (type) {
      this.$refs.form.validate(valid => {

        if (valid) {
          this.submitLoading = true
          let message = '';
          this.form.status=type
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateWithdraw(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addWithdraw(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
